/**
 * Helpers for reading values back out of form state.
 *
 * Dropdown fields store their selection as an object (`{ id, name }`), so any
 * code that builds a URL, a payload or a comparison from a form value has to
 * normalize it first - `String(value)` on a dropdown yields "[object Object]".
 */

/**
 * Normalize a form value to a trimmed string.
 *
 * Returns the string itself, or a dropdown object's `id` (falling back to its
 * `name`), or `undefined` when there is nothing usable.
 */
export function toStringValue(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") return raw.trim();
  if (typeof raw === "object") {
    const o = raw as { id?: unknown; name?: unknown };
    if (typeof o.id === "string") return o.id.trim();
    if (typeof o.name === "string") return o.name.trim();
  }
  return undefined;
}

/** {@link toStringValue} with an empty-string fallback, for required payloads. */
export const toRequiredStringValue = (raw: unknown): string =>
  toStringValue(raw) ?? "";
